export const nylasIsFetching = state => state.nylas.loading;